// extracted by css-extract-rspack-plugin
export default {"testValueFormControl":"RegexTesterDialog-module__testValueFormControl__gF5_q"};